/**
 * Sentry configuration constants
 */
export const SENTRY_DSN =
  "https://fe99934dcdc537d84209893a3f96a196@o4505462064283648.ingest.us.sentry.io/4508184596054016";
